import { render, staticRenderFns } from "./InstitutionImport.vue?vue&type=template&id=c9b58a22&scoped=true&"
import script from "./InstitutionImport.vue?vue&type=script&lang=js&"
export * from "./InstitutionImport.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionImport.vue?vue&type=style&index=0&id=c9b58a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b58a22",
  null
  
)

export default component.exports